/** @jsx jsx */
import { jsx, Box, Flex } from 'theme-ui';
import React, { FunctionComponent } from 'react';

// Components
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';
import Text, { TEXT_TYPES } from '../text';

// Icons
import FacebookSVG from '../../../static/assets/icons/social/Facebook.svg';
import LinkedInSVG from '../../../static/assets/icons/social/LinkedIn.svg';
import TwitterSVG from '../../../static/assets/icons/social/Twitter.svg';

// Styles
import * as style from './style';

interface ShareProps {
  className?: string;
}

const Share: FunctionComponent<ShareProps> = ({ className }) => {
  const url = React.useMemo(
    () =>
      typeof window !== 'undefined' ? encodeURI(window.location.href) : '',
    [],
  );

  return (
    <Box className={className}>
      <Text type={TEXT_TYPES.H4} sx={style.ShareTitle}>
        Share with Your Network
      </Text>
      <Flex sx={style.IconBox}>
        <FacebookShareButton quote="" url={url} sx={style.iconContainer}>
          <FacebookSVG sx={style.ShareIcon} />
        </FacebookShareButton>
        <LinkedinShareButton url={url} sx={style.iconContainer}>
          <LinkedInSVG sx={style.ShareIcon} />
        </LinkedinShareButton>
        <TwitterShareButton url={url} sx={style.iconContainer}>
          <TwitterSVG sx={style.ShareIcon} />
        </TwitterShareButton>
      </Flex>
    </Box>
  );
};

export default Share;
